import type { CustomSlide } from 'src/content/screens/slide-element';
import { t } from 'src/i18n';

export const slideTemplates: CustomSlide[] = [
  {
    type: 'custom',
    id: 'media-right',
    name: t('screens.slideTemplates.mediaRight'),
    duration: 10,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'divider',
      orientation: 'horizontal',
      firstDivisionSize: 50,
      first: {
        type: 'divider',
        orientation: 'vertical',
        firstDivisionSize: 50,
        first: {
          type: 'header',
        },
        last: {
          type: 'text',
        },
      },
      last: {
        type: 'media',
        left: 0,
        top: 0,
        scale: 100,
      },
    },
  },
  {
    type: 'custom',
    id: 'media-left',
    name: t('screens.slideTemplates.mediaLeft'),
    duration: 10,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'divider',
      orientation: 'horizontal',
      firstDivisionSize: 50,
      first: {
        type: 'media',
        left: 0,
        top: 0,
        scale: 100,
      },
      last: {
        type: 'divider',
        orientation: 'vertical',
        firstDivisionSize: 50,
        first: {
          type: 'header',
        },
        last: {
          type: 'text',
        },
      },
    },
  },
  {
    type: 'custom',
    id: 'media-top',
    name: t('screens.slideTemplates.mediaTop'),
    duration: 8,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'divider',
      orientation: 'vertical',
      firstDivisionSize: 50,
      first: {
        type: 'media',
        left: 0,
        top: -47,
        scale: 237,
      },
      last: {
        type: 'divider',
        orientation: 'vertical',
        firstDivisionSize: 50,
        first: {
          type: 'header',
        },
        last: {
          type: 'text',
        },
      },
    },
  },
  {
    type: 'custom',
    id: 'media-bottom',
    name: t('screens.slideTemplates.mediaBottom'),
    duration: 5,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'divider',
      orientation: 'vertical',
      firstDivisionSize: 50,
      first: {
        type: 'divider',
        orientation: 'vertical',
        firstDivisionSize: 50,
        first: {
          type: 'header',
        },
        last: {
          type: 'text',
        },
      },
      last: {
        type: 'media',
        left: 0,
        top: -47,
        scale: 237,
      },
    },
  },
  {
    type: 'custom',
    id: 'media-behind',
    name: t('screens.slideTemplates.mediaBehind'),
    duration: 12,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'media',
      left: 0,
      top: 0,
      scale: 120,
      overlayColor: 'hsla(0, 0%, 0%, 0.5)',
      blur: 0.5,
      overlayElement: {
        type: 'divider',
        orientation: 'vertical',
        firstDivisionSize: 50,
        first: {
          type: 'header',
          textColor: 'white',
          textAlign: 'center',
        },
        last: {
          type: 'text',
          textColor: 'white',
          textAlign: 'center',
        },
      },
    },
  },
  {
    type: 'custom',
    id: 'text-only',
    name: t('screens.slideTemplates.textOnly'),
    duration: 5,
    header: '',
    text: '',
    media: '',
    layout: {
      type: 'divider',
      orientation: 'vertical',
      firstDivisionSize: 50,
      first: {
        type: 'header',
        textAlign: 'center',
      },
      last: {
        type: 'text',
        textAlign: 'center',
      },
    },
  },
  {
    type: 'custom',
    id: 'media-only',
    name: t('screens.slideTemplates.mediaOnly'),
    duration: 8,
    header: '',
    text: '',
    media: 'std/rh100.webp',
    layout: {
      type: 'media',
      left: 0,
      top: 0,
      scale: 120,
    },
  },
];
